import { render, staticRenderFns } from "./CardCompanyProfessional.vue?vue&type=template&id=098e7e0a&scoped=true"
import script from "./CardCompanyProfessional.vue?vue&type=script&lang=js"
export * from "./CardCompanyProfessional.vue?vue&type=script&lang=js"
import style0 from "./CardCompanyProfessional.vue?vue&type=style&index=0&id=098e7e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e7e0a",
  null
  
)

export default component.exports